import { render } from "./index.vue?vue&type=template&id=bac4daca&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=bac4daca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bac4daca"

export default script